import defaultTheme from '@themes/default'
import { ThemeType } from '@themes/default/types'

const darkTheme = defaultTheme satisfies ThemeType

export default darkTheme
